import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { ReactElement } from "react";
import { VesselParticulars } from "./vessel-info/vesselParticulars";
import { EarlyReleaseMessage } from "./early-release/EarlyReleaseMessage";
import { DataSharingBlockedMessage } from "./data-sharing/DataSharingBlockedMessage";

export const VesselInformation = (): ReactElement => {
    return (
        <div>
            <EarlyReleaseMessage />
            <VesselParticulars />
            <DataSharingBlockedMessage />
        </div>
    );
};
